import axios from 'axios';
import http from '../http';

export class AWSS3 {
  public upload = (file: string | File | Blob, url: string, contentType: string) => {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const axiosResponse = axios.create();
        await axiosResponse.put(url, file, { headers: { 'Content-Type': contentType } });
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  };

  public async getKey(contentType: string, fileName: string, path: string): Promise<string> {
    const key = `${path}/${fileName}.msgpack`;
    const { data } = await http().post(`wrapper/files/upload-url`, { id: key, contentType });
    return data;
  }

  public async getValue(key: string): Promise<string> {
    const { data } = await http().post(`wrapper/files/download-url`, { id: key });
    return data;
  }
}
